module.exports = __webpack_public_path__ + "static/media/snare.bc394356.wav";